
        import type { TemplateResult, TemplateRootPropsForTag } from 'Components/types';
type singleVehicleGarageRTRootProps = TemplateRootPropsForTag<'div'>;
import { createElement as _createElement } from 'preact';
import { map as _map } from 'Utils/array';
import _translate from 'Utils/translate';
export default function singleVehicleGarageRT(): TemplateResult<singleVehicleGarageRTRootProps> {
    return _createElement('div', { 'className': 'navPages-action' }, _createElement('a', { 'className': 'cm_single-vehicle-garage' }, [this.changeButton(function () {
            return _createElement('div', {
                'aria-label': 'button',
                'className': 'cm_changeButton'
            }, _createElement('div', { 'className': 'garage-icon cm_icon_garage__background' }), ' \n      ', this.template === 'active' ? _createElement('div', {
                'className': 'cmTemplate_active',
                'key': '126'
            }, window.Convermax.config?.selectYourVehicleTitle || _translate(`ymm_bar_title`)) : null, this.template === 'locked' ? _createElement('div', {
                'className': 'cmTemplate_locked',
                'key': '296'
            }, this.vehicleString) : null);
        }, {
            widgetName: 'undefined',
            items: undefined
        })], this.template === 'locked' ? _createElement('div', {
        'onClick': this.goToResults,
        'className': 'go-to-results cmTemplate_locked',
        'key': '910'
    }, _createElement('span', {}, '>')) : null, this.template === 'locked' ? _createElement('div', {
        'onClick': this.discardVehicle,
        'className': 'clear-garage cmTemplate_locked',
        'key': '1069'
    }, _createElement('span', {}, _translate(`single_vehicle_garage_clear`))) : null));
}
        export const componentNames = ["cm:changeButton"]